export const documentation = {
  junior: [
    { name: 'Infrastructure Standards', url: '/docs/infrastructure-standards', type: 'standards' },
    { name: 'CI/CD Pipeline Guidelines', url: '/docs/cicd-guidelines', type: 'process' },
    { name: 'Container Best Practices', url: '/docs/container-best-practices', type: 'containerization' },
    { name: 'Monitoring and Alerting Setup', url: '/docs/monitoring-setup', type: 'monitoring' },
    { name: 'Incident Response Procedures', url: '/docs/incident-response', type: 'operations' }
  ],
  mid: [
    { name: 'Infrastructure as Code Standards', url: '/docs/iac-standards', type: 'infrastructure' },
    { name: 'Security Implementation Guide', url: '/docs/security-implementation', type: 'security' },
    { name: 'Performance Optimization Guide', url: '/docs/performance-optimization', type: 'performance' },
    { name: 'Disaster Recovery Procedures', url: '/docs/disaster-recovery', type: 'reliability' },
    { name: 'Cost Optimization Strategies', url: '/docs/cost-optimization', type: 'operations' }
  ],
  senior: [
    { name: 'DevOps Strategy Framework', url: '/docs/devops-strategy', type: 'strategy' },
    { name: 'Site Reliability Engineering Guide', url: '/docs/sre-guide', type: 'reliability' },
    { name: 'Cloud Architecture Principles', url: '/docs/cloud-architecture', type: 'architecture' },
    { name: 'Team Leadership Guidelines', url: '/docs/devops-leadership', type: 'leadership' },
    { name: 'Technology Evaluation Framework', url: '/docs/tech-evaluation', type: 'strategy' }
  ]
};
